import { render, staticRenderFns } from "./UserAvatarGroup.vue?vue&type=template&id=0b4a3320"
import script from "./UserAvatarGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatarGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports